import { render, staticRenderFns } from "./BillingTabOverview.vue?vue&type=template&id=4b992ea2"
import script from "./BillingTabOverview.vue?vue&type=script&lang=js"
export * from "./BillingTabOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports